import React from 'react';
import { Helmet } from 'react-helmet';

const JsonLdList = ({ items }) => (
    <Helmet>
        {items.map((item, index) => (
            <script key={index} type="application/ld+json">
                {JSON.stringify(item)}
            </script>
        ))}
    </Helmet>
);

export default JsonLdList;
